import { Controller } from 'stimulus'
import $ from 'jquery'
import ActiveStorageDirectUploader from '~/common/behaviors/active_storage_direct_uploader'

export default class extends Controller {
  static targets = [
    'deleteFileButton',
    'hiddenFieldTemplate',
    'form',
    'filesList',
    'fileUploader',
    'sizeErrorMessage',
  ]

  static values = {
    maxAttachmentsSize: Number,
  }

  connect() {
    if (this.hasHiddenFieldTemplateTarget) {
      // the form builds a hidden value field template that we'll use as an example for new hidden values
      this.hiddenFieldTemplateNode = this.hiddenFieldTemplateTarget.cloneNode()
      this.parentNodeForNewHiddenValues = $(
        this.hiddenFieldTemplateTarget
      ).parent()
      // remove the template with empty value so no empty value is passed to controller
      this.hiddenFieldTemplateTarget.remove()
    }
  }

  deleteFile(e) {
    e.preventDefault()
    const fileId = Number(e.target.dataset.fileId)
    const parent = $(e.target).parent().first()

    // when a file is clicked, append a hidden field with its id for the controlller to delete
    let newNodeCopy = this.hiddenFieldTemplateNode.cloneNode()
    newNodeCopy.value = fileId

    this.parentNodeForNewHiddenValues.append(newNodeCopy)

    parent.remove()
  }

  listFiles(e) {
    if (this.hasFilesListTarget) {
      const files = e.target.files
      let file
      this.filesListTarget.textContent =
        files.length > 0 ? 'Selected files:' : ''
      for (let i = 0; i < files.length; i++) {
        file = document.createElement('li')
        file.textContent = files[i].name
        this.filesListTarget.append(file)
      }
    }
  }

  handleFilesUpload() {
    const uploader = new ActiveStorageDirectUploader(
      this.fileUploaderTarget,
      this.filesListTarget
    )

    if (this.hasMaxAttachmentsSizeValue) {
      if (this.totalFileSize() < this.maxAttachmentsSizeValue) {
        this.sizeErrorMessageTarget.innerText = ''
        uploader.handleFilesUpload()
      } else {
        this.sizeErrorMessageTarget.innerText = `Too many or too big attachments. Please keep it below ${this.bytesToMegabytes(
          this.maxAttachmentsSizeValue
        )}MB`

        this.fileUploaderTarget.value = ''
      }
    } else {
      uploader.handleFilesUpload()
    }
  }

  totalFileSize() {
    let totalSize = 0

    const attachedFiles = Array.from(
      this.element.querySelectorAll('.active_storage_file')
    )
    const uploaderFiles = Array.from(this.fileUploaderTarget.files)
    totalSize =
      attachedFiles.reduce(
        (total, element) => total + +element.dataset.size,
        totalSize
      ) +
      uploaderFiles.reduce(
        (total, element) => total + +element.size,
        totalSize
      ) +
      ActiveStorageDirectUploader.inProgressTotalSize()

    return totalSize
  }

  bytesToMegabytes(bytes) {
    const megabytes = bytes / (1024 * 1024)
    return megabytes
  }
}
